import ReactExport from 'react-export-excel';
const ExcelFile = ReactExport.ExcelFile
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet


export default function Download({answerSheet}) {
    // console.log(answerSheet)
    return (
        <ExcelFile element={<button style = {{padding:'12px 35px', width:'100%'}}>Download</button>}>
            <ExcelSheet data={answerSheet} name="Scorecard">
                <ExcelColumn label="Question" value="question" />
                <ExcelColumn label="Your Answer" value="your_answer" />
                <ExcelColumn label="Correct Answer" value="correct_answer" />
            </ExcelSheet>
        </ExcelFile>
    );
}